/**
 * @description 常量集合
 * @author hayho
 */

 /**
  * 比赛状态
  */
enum MatchStatus {
    '全部' = -1,
    '进行中' = 1,
    '已结束' = 3,
    '未开始' = 0,
    '已取消' = 2
};

const constant = {
  perpage: 20
}

/**
 * 开放平台网站应用 appid，用于网页端微信扫码登录
 */
const WECHAT_WEB_APPID = 'wx08c75b751c7866bb';

/**
 * 球队 logo 缺失时的默认图
 */
const DEFAULT_TEAM_LOGO = 'https://web.static.qiuzhangmen.com/1540113531324.png?imageView2/1/w/200/h/200/format/jpg/q/87';

export { MatchStatus, constant, WECHAT_WEB_APPID, DEFAULT_TEAM_LOGO }